<template lang="pug">

  .chartWrapper(ref='container')

    .chartAreaWrapper(v-dragscroll="scrollable")
      div(style="position: sticky; height: 0; left: 0;")
        canvas.canvas-axis(ref="axis")

      div(:style='areaStyle' style="height: 100%; height: 200px; outline: none")
        canvas(ref="canvas")

</template>

<script>
import Chart from 'chart.js'
import { dragscroll } from 'vue-dragscroll'

/*eslint-disable */
export default {
  props: {
    data: {'default': () => ({})},
    barsWidth: {},
    scrollable: {'default': true},
    options: {'default': () => ({})}
  },
  data () {
    return {
      width: 0,
      height: 0
    }
  },
  computed: {
    areaStyle () {
      if (this.width && this.scrollable) {
        return {'width': this.width + 'px', height: this.height + 'px'}
      }
      return {}
    }
  },
  methods: {
    calcGraphWidth (labels) {
      const base = this.$refs.container ? this.$refs.container.clientWidth : null
      const width = (this.barsWidth * 6) * labels.length
      return base && width > base ? width : null
    },
    onClick (mouseEvent, chart) {
      try {
        const labelClicked = this.data.labelsData[chart[0]._index]
        this.$emit('click', {labelClicked, labelIndex: chart[0]._index})
      } catch (e) {}
    },
    renderCanvas (canvas, canvasAxis, scrollable, onClick) {
      const chartData = this.data
      let rectangleSet = false;

      var chartTest = new Chart(canvas, {
        type: 'bar',
        data: chartData,
        options: {
          maintainAspectRatio: false,
          responsive: true,
          tooltips: {
            titleMarginBottom: 10,
            bodyFontSize: 12
          },
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              barThickness: 'flex',
              maxBarThickness: this.barsWidth,
              autoSkip: false,
              gridLines: {
                color: 'rgba(0, 0, 0, 0)'
              },
              ticks: {
                display: true,
                maxRotation: 20,
                minRotation: 0,
                beginAtZero: true
              },
              stacked: true
            }],
            yAxes: [{
              stacked: false,
              ticks: {
                beginAtZero: true,
                padding: 15,
                max: this.maxY
              }
            }]
          },
          onClick,
          animation: {
              onComplete: function () {
                  if (!rectangleSet) {
                      var scale = window.devicePixelRatio;

                      var sourceCanvas = chartTest.chart.canvas;
                      var copyWidth = chartTest.scales['y-axis-0'].width - 10;
                      var copyHeight = chartTest.scales['y-axis-0'].height + chartTest.scales['y-axis-0'].top + 10;

                      var targetCtx = canvasAxis.getContext("2d");

                      targetCtx.scale(scale, scale);
                      targetCtx.canvas.width = copyWidth * scale;
                      targetCtx.canvas.height = copyHeight * scale;

                      targetCtx.canvas.style.width = `${copyWidth}px`;
                      targetCtx.canvas.style.height = `${copyHeight}px`;
                      targetCtx.drawImage(sourceCanvas, 0, 0, copyWidth * scale, copyHeight * scale, 0, 0, copyWidth * scale, copyHeight * scale);

                      var sourceCtx = sourceCanvas.getContext('2d');

                      // Normalize coordinate system to use css pixels.

                      sourceCtx.clearRect(0, 0, copyWidth * scale, copyHeight * scale);
                      rectangleSet = true;
                  }
              },
              onProgress: function () {
                  if (rectangleSet === true) {
                      var copyWidth = chartTest.scales['y-axis-0'].width;
                      var copyHeight = chartTest.scales['y-axis-0'].height + chartTest.scales['y-axis-0'].top + 20;

                      var sourceCtx = chartTest.chart.canvas.getContext('2d');
                      sourceCtx.clearRect(0, 0, copyWidth, copyHeight);
                  }
              }
          },
          ...this.options
        },
      });
    }
  },
  mounted () {
    this.width = this.calcGraphWidth(this.data.labels)
    this.height = this.$refs.container.clientHeight
    this.$forceUpdate()

    this.renderCanvas(this.$refs.canvas, this.$refs.axis, this.scrollable, this.onClick)
  },
  directives: {dragscroll}
}
/* eslint-enable */
</script>

<style scoped>
.chartWrapper {
  position: relative;
  height: 100%;
}

.canvas-axis {
  position: sticky;
  left: 0;
  top: 0;
  pointer-events: none;
  z-index: 1000;
}

.chartAreaWrapper {
  overflow-y: hidden;
  width: 100%;
  height: 100%;
  top: 0;
  position: relative;
  overflow-x: auto;
  outline: none;
}

</style>
